import { render, staticRenderFns } from "./OnboardingUserStatus.vue?vue&type=template&id=3da6f784&scoped=true&"
import script from "./OnboardingUserStatus.vue?vue&type=script&lang=ts&"
export * from "./OnboardingUserStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6f784",
  null
  
)

export default component.exports